(ns bp-clients.tv-app.pages.page-list
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.common.components.thumb :as thumb-components]
   [bp-clients.tv-app.common.components.vertical-scroll-with-lazy-rendering :refer [vertical-scroll-with-lazy-rendering]]
   [bp-clients.tv-app.nav.subs :as nav-subs]
   [bp-clients.tv-app.utils.utils :refer [cloudinary-image]]
   [bp-clients.tv-app.utils.window :as window]
   [bp-libs.design-system.components.banner :refer [main]]
   [bp-libs.design-system.components.carousel :refer [carousel]]
   [bp-libs.design-system.components.thumb :refer [thumb]]
   [re-frame.core :as rf]))

(defn- gen-loading-shimmers
  [count]
  (mapv (fn [_] [:div {:class "w-full h-full dark-linear-gradient rounded-lg"}
                 [thumb-components/safe-thumb {:container {:height "320px" :width "220px"}}]]) (range count)))

(defn- rating-component
  [active-item]
  [:div {:style {:height "24px"}}
   [thumb {:container {:width "24px" :height "24px"}
           :image-url (-> active-item :banner :rating :url)}]])

(defn- insert-in [i coll item]
  (let [[a b] (split-at i coll)]
    (concat a [item] b)))

(defn page-list
  []
  (let [active-page-data (rf/subscribe [::nav-subs/active-page-data])
        active-page      (rf/subscribe [::nav-subs/active-page])
        active-nav       (rf/subscribe [::nav-subs/active-nav])]
    (fn []
      (let [{:keys [page keep-watching active-item
                    banner-transition-in-progress?]} @active-page-data
            components                               (:components page)
            ref                                      (createRef)
            window-size                              (window/size)
            keep-watching-position                   (:keep-watching-position page)
            components                               (map-indexed (fn [i c] (assoc c :index i)) components)
            keep-watching-component                  {:__typename "keep_watching"
                                                      :items      (:items keep-watching)}
            components                               (if (-> keep-watching :items seq)
                                                       (insert-in (or keep-watching-position 1) components keep-watching-component)
                                                       components)
            rating-image                             (when (-> active-item :banner :rating)
                                                       [rating-component active-item])
            advisories                               (-> active-item :banner :rating :advisory)
            logo                                     (when (-> active-item :banner :logo seq)
                                                       (cloudinary-image (-> active-item :banner :logo)
                                                                         {:trim? true
                                                                          :width (some-> window-size :width (/ 3) js/Math.ceil)}))
            extra-info                               (-> active-item :banner :extra_info (or []))
            tags                                     (filter (comp not nil?) (concat extra-info (apply vector rating-image advisories)))
            background-thumb-url                     (cloudinary-image (-> active-item :banner :background_image)
                                                                       (update window-size :height #(-> % (* 0.7) js/Math.ceil)))]
        [:div {:class ["bg-black min-h-screen pl-8 relative"]
               :ref   ref}

         [:div {:class ["h-[60vh] pl-2 overflow-hidden"
                        (if banner-transition-in-progress? "opacity-30" "opacity-100")
                        "transition-opacity duration-1000 ease-in-out"]}
          ^{:key (str "banner-" banner-transition-in-progress? "-" (:id active-item))}
          [main {:tags                    tags
                 :description             (when-not (-> active-item :banner :keep_watching_info)
                                            (-> active-item :banner :description))
                 :title                   (or (-> active-item :banner :title) (:title active-item))
                 :subtitle                (-> active-item :banner :subtitle)
                 :teachers                (-> active-item :banner :teachers)
                 :hide-banner?            (nil? active-item)
                 :show-play?              false
                 :banner-logo-url         logo
                 :background-thumb-url    background-thumb-url
                 :keep-watching           (-> active-item :banner :keep_watching_info :completion_percentage)
                 :keep-watching-time-left (-> active-item :banner :keep_watching_info :remaining_description)}]]
         [:div {:class ["h-[55vh] overflow-scroll hide-scroll-bar relative -mt-[15vh] pl-8"]}
          (if (empty? components)
            (let [shimmers (gen-loading-shimmers 10)]
              [:div {:class "mt-10 space-y-10"}
               [carousel {:thumbs shimmers}]
               [carousel {:thumbs shimmers}]])

            ^{:key (str "vertical-scroll-" @active-nav @active-page (hash components))}
            [vertical-scroll-with-lazy-rendering {:components components
                                                  :autofocus? true}])]]))))
